export const messages = {
  en: {
    storeOrderCart: {
      title: 'Order Management',
      queryConditions: 'Query Conditions',
      orderInfo: 'Order Information',
      orderId: 'Order ID',
      productName: 'Product Name',
      quantity: 'Quantity',
      platform: 'Platform',
      type: 'Type',
      userName: 'User Name',
      paymentAmount: 'Payment Amount',
      discountAmount: 'Discount Amount',
      orderStatus: 'Order Status',
      createTime: 'Create Time',
      operations: 'Operations',
      query: 'Query',
      reset: 'Reset',
      export: 'Export',
      delivery: 'Delivery',
      stockComplete: 'Stock Complete',
      reprint: 'Reprint',
      orderDetail: 'Order Detail',
      deliveryConfirmation: 'Delivery Confirmation',
      recipient: 'Recipient',
      receiveTime: 'Receive Time',
      receiveAddress: 'Receive Address',
      deliveryMethod: 'Delivery Method',
      expressNumber: 'Express Number',
      expressCompany: 'Express Company',
      remarks: 'Remarks',
      close: 'Close',
      confirmDelivery: 'Confirm Delivery',
      selectDeliveryMethod: 'Please select delivery method',
      inputExpressNumber: 'Please input express number',
      selectExpressCompany: 'Please select express company'
    }
  },
  zh: {
    storeOrderCart: {
      title: '订单管理',
      queryConditions: '查询条件',
      orderInfo: '订单信息',
      orderId: '订单号',
      productName: '商品名称',
      quantity: '购买数量',
      platform: '平台',
      type: '类型',
      userName: '用户名称',
      paymentAmount: '支付金额',
      discountAmount: '优惠金额',
      orderStatus: '订单状态',
      createTime: '创建时间',
      operations: '操作',
      query: '查询',
      reset: '重置',
      export: '导出',
      delivery: '发货',
      stockComplete: '备货完成',
      reprint: '补打小票',
      orderDetail: '订单详情',
      deliveryConfirmation: '发货确认',
      recipient: '收货人',
      receiveTime: '收货时间',
      receiveAddress: '收货地点',
      deliveryMethod: '配送方式',
      expressNumber: '快递单号',
      expressCompany: '快递公司',
      remarks: '备注',
      close: '关闭',
      confirmDelivery: '确定发货',
      selectDeliveryMethod: '请选择配送方式',
      inputExpressNumber: '请填写快递单号',
      selectExpressCompany: '请选择快递公司'
    }
  }
}